import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import SignupModal from '../components/auth/SignupModal';
import { useSignupModal } from '../contexts/SignupModalContext';
import useScrollToTop from '../hooks/useScrollToTop';

const MainLayout = () => {
  // Scroll to top when route changes
  useScrollToTop();
  const { showSignupModal, closeSignupModal } = useSignupModal();

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
      
      {/* Signup Modal */}
      {showSignupModal && (
        <SignupModal
          isOpen={showSignupModal}
          onClose={closeSignupModal}
        />
      )}
    </div>
  );
};

export default MainLayout; 